// ============================================
// Тосты — уведомления вместо alert
// ============================================
function showToast(message, type = 'info', duration = 4000) {
  let container = document.querySelector('.skepka-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'skepka-toast-container';
    document.body.appendChild(container);
  }

  const icons = { success: '✓', error: '!', info: 'i' };

  const toast = document.createElement('div');
  toast.className = 'skepka-toast skepka-toast--' + type;
  toast.innerHTML = `
    <div class="skepka-toast__inner">
      <span class="skepka-toast__icon">${icons[type] || 'i'}</span>
      <span class="skepka-toast__text">${message}</span>
      <button class="skepka-toast__close" aria-label="Закрыть">×</button>
    </div>
  `;

  container.appendChild(toast);

  requestAnimationFrame(() => toast.classList.add('is-visible'));

  function close() {
    toast.classList.remove('is-visible');
    setTimeout(() => toast.remove(), 300);
  }

  toast.querySelector('.skepka-toast__close').addEventListener('click', close);

  if (duration > 0) setTimeout(close, duration);
}
